import { Button as MantineButton } from "@mantine/core"
import type { ButtonProps, Variants } from "@mantine/core"

//Overrides the default mantine button type to allow custom variants
type OverriddenButtonProps = Omit<ButtonProps, "variant"> & {
    variant: Variants<"filled" | "outline" | "light" | "white" | "default" | "subtle" | "gradient" | "tonal" | "ghost">
}

type OverriddenButtonType = typeof MantineButton & {
    (props: OverriddenButtonProps): ReturnType<typeof MantineButton>
}

export const Button = MantineButton as OverriddenButtonType

/*
 * For Mantine components that we are using as part of the Quorum Design System,
 * we are barrel exporting and providing documentation so that users KNOW,
 * unambiguously, that they can/should use the standard component unmodified
 */

export {
    Alert,
    ActionIcon,
    Avatar,
    Badge,
    Card,
    Container,
    CloseButton,
    Divider,
    Flex,
    Grid,
    Group,
    List,
    Modal,
    Space,
    Stack,
    Text,
    Title,
    UnstyledButton,
    Pagination,
    LoadingOverlay,
} from "@mantine/core"
